import styles from './styles/Toggle.css'
import classNames from 'classnames'

/**
 *
 * @param {Object} data
 * @param {string} data.toggleLabel Label that sits next to toggle component
 * @param {boolean} data.checked Boolean
 * @param {import('react').ChangeEventHandler} data.onChange Handle changes to the input
 * @param {boolean} [data.disabled = false] Disable the input entirely
 * @returns
 */
const Toggle = ({ toggleLabel, checked, onChange, disabled = false }) => (
  <label className={classNames(styles.toggleSwitchWrapper, { [styles.disabledSwitch]: disabled })}>
    {toggleLabel && (<span>{toggleLabel}</span>)}
    <div className={styles.toggle}>
      <label className={styles.switch}>
        <input type='checkbox' checked={disabled ? false : checked} onChange={onChange} disabled={disabled} />
        <span className={styles.slider} />
      </label>
    </div>
  </label>
)

export default Toggle
